import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numericFormatter',
  standalone: true
})
export class NumericFormatterPipe implements PipeTransform {

  transform(value: unknown): string {
    if (typeof value !== 'number' || isNaN(value)) {
      return 'Invalid number';
    }

    const absValue = Math.abs(value);

    if (absValue >= 1_000_000_000_000) {
      return (value / 1_000_000_000_000).toFixed(2) + ' T';
    }

    if (absValue >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2) + ' B';
    }

    if (absValue >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + ' M';
    }

    if (absValue >= 1_000) {
      return (value / 1_000).toFixed(2) + ' K';
    }

    // Handle very small numbers
    if (absValue > 0 && absValue < 0.0001) {
      return value.toExponential(2);
    }

    if (!Number.isInteger(value)) {
      return value.toFixed(2);
    }

    // Default → plain number with 2 decimals
    return value.toString();

  }
}
